import parseHTML from "../lib/dom/funciones/parse_html";
var video = function () {
    var contenedor = document.querySelector('.cabecera__video');
    if (!contenedor)
        return;
    var video = contenedor.querySelector('video');
    video.id = 'video-cabecera';
    var boton = parseHTML("<button class=\"cabecera__video__boton\" aria-label=\"Reproducir video\" aria-controls=\"video-cabecera\" aria-pressed=\"false\">\n<svg width=\"55\" height=\"55\" viewBox=\"0 0 55 55\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<circle cx=\"27.3988\" cy=\"27.8606\" r=\"26.3828\" stroke=\"black\" stroke-width=\"1.25633\"/>\n<path d=\"M23.0017 36.0266V19.6943L36.8213 27.5338L23.0017 36.0266Z\" stroke=\"black\" stroke-width=\"1.25633\"/>\n</svg>\n</button>");
    contenedor.insertBefore(boton, contenedor.firstChild);
    var activarBoton = function () {
        boton.setAttribute('aria-pressed', 'false');
        video.controls = false;
    };
    var desactivarBoton = function () {
        boton.setAttribute('aria-pressed', 'true');
        video.controls = true;
    };
    video.addEventListener('ended', activarBoton);
    video.addEventListener('pause', activarBoton);
    video.addEventListener('play', desactivarBoton);
    boton.addEventListener('click', function () {
        video.play();
        desactivarBoton();
    });
};
export default video;
